import {Component, EventEmitter, Inject, Injectable, OnDestroy, Output, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { mergeMap } from 'rxjs/operators';
import {GoogleAdsAccount, Integration} from '../../../../core/models/integration';
import { NgForm } from '@angular/forms';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';
import {NestedTreeControl} from "@angular/cdk/tree";
import {ArrayDataSource, CollectionViewer, DataSource, SelectionChange} from "@angular/cdk/collections";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {Observable, of, pipe, map, BehaviorSubject, merge} from "rxjs";

export class GoogleAdsAccountNode {
  private children?: GoogleAdsAccountNode[] = [];
  constructor(
    public account: GoogleAdsAccount,
    public integrationId: string,
    private integrationDao: IntegrationDao,
    public isLoading = false,
    public hasLoaded: boolean = false,
    public depth: number = 0
  ){}

  isExpandable(): boolean {
    return this.account.isMcc;
  }

  getChildren(): Observable<GoogleAdsAccountNode[]> {
    if(this.hasLoaded) {
      return of(this.children);
    } else {
      this.isLoading = true;
      return this.integrationDao.getGoogleAdsSubAccounts(
        this.integrationId,
        this.account.customerId,
        this.account.loginCustomerId || this.account.managerCustomerId
      ).pipe(map(res => {
        this.children = res.map(r => new GoogleAdsAccountNode(r, this.integrationId, this.integrationDao));
        this.isLoading = false;
        return this.children;
      }));
    }
  }
}


@Component({
  selector: 'google-ads',
  templateUrl: './google-ads.component.html',
  styleUrls: ['./google-ads.component.scss']
})
export class GoogleAdsComponent implements OnDestroy {
  private subs = [];

  loading = false;
  saving = false;

  accounts: Array<any> = [];
  noAccounts = false;
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  oauthURL = '';
  isAdmin = false;
  customerId;
  accountLinked = false;
  useCallExt = false;
  intType = 'oauth';
  @ViewChild('gaForm') gaForm: NgForm;
  creatingMcc = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  emitter: EventEmitter<any>;

  googleAccountTree: Array<GoogleAdsAccountNode> = [];
  googleAccountSource: DataSource<GoogleAdsAccountNode>;
  accountTreeControl: NestedTreeControl<GoogleAdsAccountNode>;

  hasChild = (_:number, node: GoogleAdsAccountNode) => {
    return node.account.isMcc;
  }

  constructor(
    public dialogRef: MatDialogRef<GoogleAdsComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.existingIntegrations = this.data.existingIntegrations;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
    }
    this.emitter = this.data.emitter;

    this.accountTreeControl = new NestedTreeControl<GoogleAdsAccountNode>(
      node => node.getChildren()
    )
    this.googleAccountSource = new MatTreeNestedDataSource<GoogleAdsAccountNode>();

    // let sub = this.integrationDao.getGoogleAdsOauthUrl(this.data.brand).subscribe(res => {
    //   this.oauthURL = res['url'];
    // });
    // this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  doNotSubmit(e) {
    e.preventDefault();
  }

  canSubmit(): boolean {
    if (this.gaForm) {
      return !this.gaForm.valid;
    } else {
      return true;
    }
  }

  formatCustomerId(rawId: string) {
    let customerId = rawId.substr(0, 3);
    customerId += '-';
    customerId += rawId.substr(3, 3);
    customerId += '-';
    customerId += rawId.substr(6);
    return customerId;
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  save(account: GoogleAdsAccount) {
    this.saving = true;
    // let sub = this.integrationDao
    //   .update(this.createdIntegration.id, {
    //     customerId: this.formatCustomerId(account.customerId),
    //     loginCustomerId: account.loginCustomerId?this.formatCustomerId(account.loginCustomerId):null,
    //     accountLinked: false,
    //     enabled: true,
    //     type: 'google_ads',
    //     friendlyName: account.name
    //   })
    //   .subscribe(
    //     res => {
    //       this.createdIntegration.id = res.id;
    //       this.createdIntegration.enabled = res.enabled;
    //       this.createdIntegration.accountLinked = res.accountLinked;
    //       this.createdIntegration.friendlyName = res.friendlyName;
    //       let isLinkedSub = this.integrationDao.isAccountLinked(res.id).subscribe(
    //         linkStatus => {
    //           console.log(linkStatus);
    //           if (linkStatus !== 'ACTIVE') {
    //             let linkSub = this.integrationDao.linkGoogleAccount(res.id).subscribe(
    //               linkResult => {
    //                 console.log(linkResult);
    //                 this.createdIntegration.accountLinked = true;
    //                 this.saving = false;
    //                 this.dialogRef.close(this.createdIntegration);
    //               },
    //               err => console.error(err)
    //             );
    //             this.subs.push(linkSub);
    //           }
    //         },
    //         err => console.error(err)
    //       );
    //       this.subs.push(isLinkedSub);
    //     },
    //     err => console.error(err)
    //   );
    // this.subs.push(sub);
  }

  saveMcc() {
    this.creatingMcc = true;
    this.data.customerId = this.formatCustomerId(this.customerId);
    this.data.useCallExt = this.useCallExt;
    this.data.type = 'google_ads';
    this.data.version = 'legacy';
    this.data.friendlyName = this.formatCustomerId(this.customerId);
    let int = {
      brand: this.data.brand,
      customerId: this.data.customerId,
      friendlyName: this.data.friendlyName,
      type: this.data.type,
      useCallExt: this.useCallExt,
      version: this.data.version
    };
    if (!this.data.id) {
      // let sub = this.integrationDao.createIntegration(int).subscribe(
      //   (result: Integration) => {
      //     this.createdIntegration = result;
      //     this.data.id = result.id;
      //     this.data.enabled = result.enabled;
      //     this.data.accountLinked = result.accountLinked;
      //     this.accountLinked = result.accountLinked;
      //     if (!this.accountLinked) {
      //       this.verify();
      //     }
      //     this.creatingMcc = false;
      //     this.done();
      //   },
      //   err => console.error(err)
      // );
      // this.subs.push(sub);
    }
  }

  verify() {
    this.loading = true;
    // let sub = this.integrationDao.isAccountLinked(this.data.id).subscribe(
    //   res => {
    //     if (res.linked) {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.data.accountLinked = true;
    //         this.accountLinked = true;
    //       }, 500);
    //     } else {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.data.accountLinked = false;
    //         this.accountLinked = false;
    //       }, 500);
    //     }
    //   },
    //   err => {
    //     console.error(err);
    //     this.loading = false;
    //   }
    // );
    // this.subs.push(sub);
  }

  done() {
    this.dialogRef.close(this.createdIntegration);
  }

  onClick(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    let opened = window.open(this.oauthURL, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'google_ads' && event.data.id !== undefined) {
          this.loading = true;
          this.noAccounts = false;
          let intSub = this.integrationDao
              .loadById(event.data.id)
              // .pipe(
              //     mergeMap(res => {
              //       this.createdIntegration = res;
              //      // return this.integrationDao.getGoogleAdsAccounts(this.createdIntegration.id);
              //     })
              // )
          //     .subscribe(accounts => {
          //       this.googleAccountTree = accounts.map(acct => new GoogleAdsAccountNode(acct, this.createdIntegration.id, this.integrationDao));
          //       this.googleAccountSource = new ArrayDataSource(this.googleAccountTree);
          //       if (!this.googleAccountTree.length) {
          //         this.noAccounts = true;
          //       }
          //       this.loading = false;
          //     });
          // this.subs.push(intSub);

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        }
      }
    }

    window.addEventListener('message', listener);
  }
}
